import { render, staticRenderFns } from "./DowntimeCategoryView.vue?vue&type=template&id=50d1778a"
import script from "./DowntimeCategoryView.vue?vue&type=script&lang=js"
export * from "./DowntimeCategoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports